import { IonCol, IonContent, IonGrid, IonIcon, IonModal, IonPage, IonRow } from '@ionic/react';
import { closeSharp, shareOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
// import Email from '../../components/Email';
import Options from '../../components/Options';
import PopularProcessGoals from '../../components/PopularProcessGoals';
import Topics from '../../components/Topics';
import './HomePage.scss';

export default function HomePage(props: {
  screenSize: number;
}) {
  const { screenSize } = props;
  const [paddingStyle, setPaddingStyle] = useState('');
  const [prompt, setPrompt] = useState<any>();
  // const modalDefault = useRef<HTMLIonModalElement>(null);
  const modalIOS = useRef<HTMLIonModalElement>(null);
  const [displayInitialPrompt, setDisplayInitialPrompt] = useState('none');

  // Detects if device is on iOS
  const isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    console.log('userAgent: ', userAgent);
    return /iphone|ipad|ipod|mac os/.test(userAgent);
  };
  // Detects if device is in standalone mode
  const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches;

  useEffect(() => {
    if (screenSize < 500) {
      setPaddingStyle('padding-xs');
    } else {
      setPaddingStyle('padding-md');
    }
  }, [screenSize]);

  useEffect(() => {
    const handleStorePrompt = (e: any) => {
      e.preventDefault();
      setPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', (e) => {
      handleStorePrompt(e);

      console.log('before');
      // if (!isIos() && !isInStandaloneMode) {
      //   setTimeout(() => {
      //     document.getElementById('open-default-prompt')?.click();
      //   }, 1000);
      // }
      if (!isIos() && !isInStandaloneMode) {
        setDisplayInitialPrompt('block');
      }
    });

    if (isIos() && !isInStandaloneMode) {
      setDisplayInitialPrompt('block');
    }
    return () => {
      window.removeEventListener('beforeinstallprompt', (e) => handleStorePrompt(e));
    };
  }, []);

  const handlePrompt = async () => {
    prompt?.prompt();
    prompt.userChoice
      .then((choice: any) => {
        if (choice.outcome === 'accepted') {
          console.log('User accepted');
        } else {
          console.log('User dismissed');
        }
        setPrompt(null);
      });
  };

  const iosPrompt = () => (
    <IonModal ref={modalIOS} trigger="open-ios-modal" initialBreakpoint={0.22} breakpoints={[0, 0.22, 0.35, 0.5, 0.65, 0.75]}>
      <IonContent className="ion-padding">
        <IonGrid style={{ padding: '0px', borderRadius: '8px' }}>
          <IonRow>
            <IonCol size="2">
              {/* eslint-disable-next-line global-require */}
              <img alt="" src={require('./promp-icons/ios-120x120.png')} />
            </IonCol>
            <IonCol size="10">
              <IonRow style={{ fontFamily: 'AgrandirRegular', fontSize: '14px' }}>
                DA ToolKit
              </IonRow>
              <IonRow style={{ fontFamily: 'AgrandirRegular', fontSize: '14px' }}>
                To install this PWA on your device:
              </IonRow>
              <IonRow style={{ marginTop: '10px', fontFamily: 'AgrandirRegular', fontSize: '12px' }}>
                1. Open in Safari Browser
              </IonRow>
              <IonRow style={{ fontFamily: 'AgrandirRegular', fontSize: '12px' }}>
                2. Tap Share
                <IonIcon src={shareOutline} style={{ color: '#4F17A8', fontSize: '16px', padding: '0px 4px' }} />
                in Navigation bar
              </IonRow>
              <IonRow style={{ fontFamily: 'AgrandirRegular', fontSize: '12px' }}>
                {/* eslint-disable-next-line */}
                3. Select "Add to Homescreen" then tap Add
              </IonRow>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonModal>
  );

  // const defaultPrompt = () => (
  //   <IonModal ref={modalDefault} trigger="open-default-prompt" initialBreakpoint={0.1} breakpoints={[0, 0.1, 0.15, 0.25, 0.35, 0.5, 0.75]}>
  //     <IonContent className="ion-padding">
  //       <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
  //         <button type="submit" onClick={handlePrompt} style={{ padding: '12px', width: '100%', background: '#4717A8', fontFamily: 'HelveticaRegular' }}>
  //           INSTALL APP
  //         </button>
  //       </div>
  //     </IonContent>
  //   </IonModal>
  // );

  const setInitialPrompt = () => setDisplayInitialPrompt('none');

  const showPrompt = () => {
    setDisplayInitialPrompt('none');
    if (isIos() && !isInStandaloneMode) {
      document.getElementById('open-ios-modal')?.click();
    } else if (!isIos() && !isInStandaloneMode) {
      handlePrompt();
    }
  };

  const initialPrompt = () => (
    <IonGrid style={{ display: displayInitialPrompt, background: '#FFF', width: '100%', position: 'sticky', zIndex: '1000', top: '0px', padding: '16px' }}>
      <IonRow>
        <IonCol size="1" style={{ padding: '0px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <IonIcon
            style={{ fontSize: '18px', cursor: 'pointer' }}
            src={closeSharp}
            onClick={setInitialPrompt}
          />
        </IonCol>
        <IonCol size="6" style={{ padding: '0px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', fontFamily: 'AgrandirRegular' }}>
          Download the app
        </IonCol>
        <IonCol
          size="4"
          style={{ padding: '0px', display: 'flex', alignItems: 'center', justifyContent: 'end', fontFamily: 'AgrandirRegular' }}
        >
          <button className="go-to-app" type="button" onClick={showPrompt}>Go to App</button>
        </IonCol>
      </IonRow>
    </IonGrid>
  );

  return (
    <IonPage>
      <IonContent>
        {initialPrompt()}
        {iosPrompt()}
        {/* {defaultPrompt()} */}
        {/* <button id="open-default-prompt" type="submit" style={{ display: 'none' }}>default install prompt</button> */}
        <button id="open-ios-modal" type="submit" style={{ display: 'none' }}>ios install prompt</button>
        <div className="header-topic-gradient">
          <div className={`padding-header ${paddingStyle}`}>
            <p className="header-text-style text-header" data-testid="homepage-header">Tool Kit</p>
            <p className="header-text-style text-subheader" data-testid="homepage-subheader">Disciplined Agile</p>
          </div>
          <div className={paddingStyle}>
            <Topics screenSize={screenSize} />
          </div>
        </div>
        <div className={paddingStyle}>
          <Options />
        </div>
        <div className={`popular-process-goals-section  ${paddingStyle}`}>
          <PopularProcessGoals screenSize={screenSize} />
        </div>
        {/* <div className={paddingStyle}>
          <Email />
        </div> */}
      </IonContent>
    </IonPage>
  );
}
